'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tooltip = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip(props, context) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props, context));

    _this.state = {
      isShowingTooltip: false
    };

    _this.delayShowTooltip = _this.delayShowTooltip.bind(_this);
    _this.hideTooltip = _this.hideTooltip.bind(_this);
    return _this;
  }

  _createClass(Tooltip, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoLoad) {
        this.delayShowTooltip();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.state.displayTimeout);
      clearTimeout(this.state.delayTimeout);
    }
  }, {
    key: 'delayShowTooltip',
    value: function delayShowTooltip() {
      var _this2 = this;

      if (this.props.delayTime) {
        this.setState({
          delayTimeout: setTimeout(function () {
            _this2.showTooltip();
          }, this.props.delayTime)
        });
      } else {
        this.showTooltip();
      }
    }
  }, {
    key: 'showTooltip',
    value: function showTooltip() {
      // show the tooltip and set a timeout to fade it out
      // store the handle to the timeout in the state
      this.setState({
        isShowingTooltip: true,
        displayTimeout: this.delayHideTooltip(this.props.displayTime)
      });
    }
  }, {
    key: 'delayHideTooltip',
    value: function delayHideTooltip(time) {
      var _this3 = this;

      if (!time) return null;
      return setTimeout(function () {
        _this3.hideTooltip();
      }, time);
    }
  }, {
    key: 'hideTooltip',
    value: function hideTooltip() {
      // if the timeout was set, clear it so that subsequent
      // mouse enters show the tooltip
      clearTimeout(this.state.displayTimeout);
      clearTimeout(this.state.delayTimeout);
      this.setState({
        isShowingTooltip: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var displayClass = (0, _classnames2.default)(_styles2.default.tooltip__display, _styles2.default['tooltip__display--' + this.props.env], _styles2.default['tooltip__display--' + this.props.position], _styles2.default['tooltip__display--' + (this.state.isShowingTooltip ? 'active' : 'inactive')]);

      return _react2.default.createElement(
        'div',
        {
          className: this.props.className.concat(' ' + _styles2.default.tooltip__container),
          key: this.props.keyValue,
          style: this.props.style,
          title: this.props.title,
          onClick: this.props.onClick,
          'data-hudl-element': this.props.title,
          onContextMenu: this.props.onContextMenu,
          onMouseEnter: this.props.autoLoad ? function () {} : this.delayShowTooltip,
          onMouseLeave: this.props.autoLoad ? function () {} : this.hideTooltip
        },
        this.props.children,
        _react2.default.createElement(
          'span',
          { className: displayClass },
          this.props.text
        )
      );
    }
  }]);

  return Tooltip;
}(_react2.default.Component);

Tooltip.propTypes = {
  autoLoad: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  delayTime: _react.PropTypes.number,
  displayTime: _react.PropTypes.number,
  env: _react.PropTypes.oneOf(['dark', 'light', 'bright']),
  keyValue: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  onClick: _react.PropTypes.func,
  onContextMenu: _react.PropTypes.func,
  position: _react.PropTypes.oneOf(['top', 'top-left', 'top-right', 'right', 'left', 'bottom', 'bottom-left', 'bottom-right']),
  style: _react.PropTypes.object,
  text: _react.PropTypes.node.isRequired,
  title: _react.PropTypes.string
};
Tooltip.contextTypes = {
  state: _react.PropTypes.object
};
Tooltip.defaultProps = {
  autoLoad: false,
  className: '',
  delayTime: 0,
  displayTime: 0,
  env: 'light',
  position: 'top'
};
exports.default = Tooltip;